import React, { useState, useEffect } from 'react';
import ContactHeroForm from './ContactHeroForm';
import ContactInfoForm from './ContactInfoForm';
import ContactFaqForm from './ContactFaqForm';
import ContactPartnershipsForm from './ContactPartnershipsForm';
import ContactTestimonialsForm from './ContactTestimonialsForm';
import ContactCountdownForm from './ContactCountdownForm';
import { 
  PhoneCall, 
  MapPin, 
  HelpCircle, 
  Building2, 
  Quote, 
  Calendar 
} from 'lucide-react';
import './FormsUnified.css';

const TABS = [
  { id: 'hero', title: 'Hero Section', icon: PhoneCall, component: ContactHeroForm },
  { id: 'info', title: 'Contact Info & Location', icon: MapPin, component: ContactInfoForm },
  { id: 'faq', title: 'FAQ', icon: HelpCircle, component: ContactFaqForm },
  { id: 'partnerships', title: 'Partnerships', icon: Building2, component: ContactPartnershipsForm },
  { id: 'testimonials', title: 'Testimonials Header', icon: Quote, component: ContactTestimonialsForm },
  { id: 'countdown', title: 'Campus Construction', icon: Calendar, component: ContactCountdownForm }
];

export default function ContactForm({ apiBase, activeTab }) {
  const getInitialTab = () => {
    if (activeTab === 'cms-con-info' || activeTab === 'cms-con-location' || activeTab === 'info' || activeTab === 'location') return 'info';
    if (activeTab === 'cms-con-faq' || activeTab === 'faq') return 'faq';
    if (activeTab === 'cms-con-partnerships' || activeTab === 'partnerships') return 'partnerships';
    if (activeTab === 'cms-con-testimonials' || activeTab === 'testimonials') return 'testimonials';
    if (activeTab === 'cms-con-countdown' || activeTab === 'cms-countdown' || activeTab === 'countdown') return 'countdown';
    return 'hero';
  };

  const [currentTab, setCurrentTab] = useState(getInitialTab);

  useEffect(() => {
    setCurrentTab(getInitialTab());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  const activeTabConfig = TABS.find(t => t.id === currentTab) || TABS[0];
  const ActiveComponent = activeTabConfig.component;

  return (
    <div className="unified-master-container">
      {/* Tab Navigation Pill Bar */}
      <div className="unified-tab-bar">
        {TABS.map((tab) => {
          const Icon = tab.icon;
          const isActive = tab.id === currentTab;

          return (
            <button
              key={tab.id}
              type="button"
              className={`tab-pill-btn ${isActive ? 'active' : ''}`}
              onClick={() => setCurrentTab(tab.id)}
            >
              <Icon size={16} />
              <span>{tab.title}</span>
            </button>
          );
        })}
      </div>

      {/* Render Active Section Sub-Form */}
      <div className="unified-tab-content">
        <ActiveComponent apiBase={apiBase} />
      </div>
    </div>
  );
}
